module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jN8FO"))).then(() => parcelRequire('8rm4T'));